import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { setIsLoading, setToastMessage } from '../../../reducers/common.reducer';
import { getResultsForSingleAgentService, updateRemainBalanceService } from '../../../services/result.service';

const Copier = ( props ) => {
    const { isSaveFormVisible, onClick, date, agentDetailData, fromDateToDate } = props;
    const [resultDataSingle, setResultDataSingle] = useState();

    let dispatch = useDispatch()

    async function getResultForSingleAgent () {
        try {
            dispatch(setIsLoading(true))
            let result = await getResultsForSingleAgentService( date, agentDetailData?.agentId || "0c09fb75-72d5-428d-917c-c6358f139de6" )
            if(result.data) {
            setResultDataSingle(result.data)
            }
        }
        catch (error) {
            dispatch(
                setToastMessage({
                message: error?.response?.data?.message || error?.message,
                type: "error",
                })
            );
        }
        finally {
            dispatch(setIsLoading(false));
        }
    }

    useEffect(()=> {
     getResultForSingleAgent();

    }, [date, agentDetailData]);

    const handleCopy = () => {

        const game = resultDataSingle.map(item =>  `${item?.gameType}.  ${Math.round(item.winLoss)}`).join("\n");

        let textToCopy = `\n${agentDetailData.agentName}\n${fromDateToDate} \n \n${game}\n \nTotal.  ${Math.round(agentDetailData?.winLoss)} \nRemain.  ${Math.round(agentDetailData?.remain -agentDetailData?.winLoss)} \nFinal.  ${Math.round(agentDetailData?.remain)}`

        navigator.clipboard.writeText(textToCopy)
          .then(() => {
            dispatch(
                setToastMessage({
                message: "copied",
                type: "success",
                })
            );

          })
          .catch(err => {
            // setCopySuccess("Failed to copy!");
            console.error("Failed to copy: ", err);
          });
      };

    return (
        <div onClick={(e)=> e.stopPropagation()}
            className={`fixed right-24 top-32  w-2/5 h-[80vh] z-50 bg-white shadow-lg rounded transform transition-transform duration-500 ease-in-out overflow-y-auto
                ${isSaveFormVisible ? 'translate-x-0' : 'translate-x-full hidden'}`
            }>
            <div className="w-[95%] mx-auto">
                <div className="mt-10 flex justify-end">
                    <button
                        className='px-16 py-2 bg-primary text-white rounded'
                        onClick={handleCopy}
                    >
                        Copy
                    </button>
                </div>

                <div className="flex justify-center mt-10 bg-bgColor py-5">
                    <p className=" font-bold text-lef text-black-800"> {`${agentDetailData?.agentName}(${fromDateToDate}) `} </p>
                </div>
                <div className=" mt-10">
                    {
                        resultDataSingle && resultDataSingle.map( item => (
                        <div className="grid grid-cols-2 text-center">
                            <p className="text-left pl-20 text-fgColor">{item?.gameType}</p>
                            <p className="mb-10 pl-28 text-fgColor">{item?.winLoss}</p>
                        </div>
                        ))
                    }
                </div>
                <div className="flex justify-between bg-bgColor py-5 px-12">
                    <p className="text-left text-fgColor pl-1">Total</p>
                    <p className="text-right text-fgColor pl-6">{agentDetailData?.winLoss}</p>
                </div>
                 <div className="flex justify-between bg-bgColor py-5 px-12">
                    <p className="text-left text-fgColor">Remain</p>
                    <p className="text-right text-fgColor border-b-2 border-blue-700 pb-10">{Math.round(agentDetailData?.remain -agentDetailData?.winLoss)}</p>
                </div>
                {/*
                <div className="flex justify-between bg-bgColor py-5 px-16">
                    <p className="text-left text-fgColor font-bold pl-1">Current Total Remain Balance</p>
                    <p className="text-right text-fgColor font-bold pl-6">{agentDetailData?.final}</p>
                </div> */}
{/*
                <div className="flex justify-between bg-bgColor py-5 px-16">
                    <p className="text-left text-fgColor font-bold pl-1"> Instant Payment </p>
                    <input className='text-right text-fgColor rounded p-2 px-5 outline-none '
                    type='text'
                    name='instantPayAmount'
                     onChange= { (e)=> setInstantPayAmount(e.target.value) }
                    />
                </div> */}
                <div className="flex justify-between bg-bgColor py-5 px-12">
                    <p className="text-left text-fgColor pl-1">All Total</p>
                    <p className="text-right text-black-800 pl-6">{agentDetailData?.remain}</p>
                </div>
            </div>
        </div>
    )
}

export default Copier;
